import WelcomeInfoBox from "./WelcomeInfoBox";

export default WelcomeInfoBox;